import type { FieldDef } from "../types";
import { FieldRow } from "./FieldRow";

interface Props {
  title: string;
  keys: string[];
  defs: Record<string, FieldDef>;
  copiedKey: string | null;
  onCopy: (key: string, value: string, label: string) => void;
  ssnRevealed: boolean;
  onToggleSsn: () => void;
}

export function FieldGroup({ title, keys, defs, copiedKey, onCopy, ssnRevealed, onToggleSsn }: Props) {
  return (
    <section className="fgroup">
      <h3 className="fgroup__title">{title}</h3>
      <div className="fgroup__rows">
        {keys.map((k) => {
          const def = defs[k];
          if (!def) return null;
          return (
            <FieldRow
              key={k}
              fieldKey={k}
              def={def}
              copiedKey={copiedKey}
              onCopy={onCopy}
              ssnRevealed={ssnRevealed}
              onToggleSsn={onToggleSsn}
            />
          );
        })}
      </div>
    </section>
  );
}
